import React from 'react';
import "./styles.css"
import TextField from '@mui/material/TextField';

const CustomRoundedInput = ({ classname = "", textCenter, isGrey, ...rest }) => {
    return (
        <div>
            <TextField {...rest}
                variant="outlined"
                size='small'
                InputProps={{ sx: { borderRadius: '5px',background:isGrey ? '#EAEAEA' : '' }}}
                inputProps={{sx:{textAlign: textCenter ? 'center' : '',fontFamily:'Josefin Sans'}}}
            />
        </div>
    );
};

export default CustomRoundedInput;